<template>
    <div>
        <button class="btn btn-outline-dark" @click="getClasses(); show = !show">Make Debate Room</button>
        <br />
        <div v-if="show">
            <br />
            <v-select
                label="Class"
                :items="classes"
                v-model="selectedClass"
                @change="getClassDeets();"
            ></v-select>
            <div v-if="students.length">
                <v-text-field label="Motion" v-model="motion" />
                <v-select
                    v-model="gov"
                    :items="items(students).filter(v => !opp.includes(v.value))"
                    label="Government"
                    multiple
                ></v-select>
                <v-select
                    v-model="opp"
                    :items="items(students).filter(v => !gov.includes(v.value))"
                    label="Opposition"
                    multiple
                ></v-select>
                <button
                    :disabled="!gov.length || !opp.length || !motion"
                    class="btn btn-sm btn-outline-success"
                    @click="submit()"
                >Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../../firebaseConfig");
export default {
    data() {
        return {
            show: false,
            classes: [],
            teachers: [],
            selectedClass: null,
            userData: {},
            students: [],
            motion: "",
            gov: [],
            opp: [],
            res: "",
        };
    },
    computed: {
        ...mapState(["admin", "userProfile"]),
    },
    methods: {
        getClasses() {
            if (this.classes.length) {
                return;
            }
            if (this.admin) {
                fb.db
                    .collection("classes")
                    .where("active", "==", true)
                    .get()
                    .then((qs) => {
                        qs.forEach((doc) => {
                            if (this.show) {
                                this.classes.push(doc.data().name);
                            }
                        });
                    });
            } else {
                this.classes = this.userProfile.classes;
            }
        },
        getClassDeets() {
            this.res = "";
            fb.db
                .collection("classes")
                .where("name", "==", this.selectedClass)
                .get()
                .then((qs) => {
                    this.teachers = qs.docs[0].data().teachers;
                    this.userData = qs.docs[0].data().userData;
                    this.students = qs.docs[0].data().students;
                });
        },
        items(v) {
            const items = [];
            for (const item of v) {
                const temp = {};
                temp["text"] = `${this.userData[item].name} - ${item}`;
                temp["value"] = item;
                items.push(temp);
            }
            return items;
        },
        submit() {
            fb.db
                .collection("debates")
                .add({
                    class: this.selectedClass,
                    gov: this.gov,
                    opp: this.opp,
                    teachers: this.teachers,
                    motion: this.motion,
                    userData: this.userData,
                    timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                })
                .then((ref) => {
                    this.copy(ref.id);
                });
            this.gov = [];
            this.opp = [];
            this.students = [];
            this.teachers = [];
            this.motion = "";
            this.selectedClass = null;
            this.show = false
        },
        copy(id) {
            const textArea = document.createElement("textarea");
            textArea.style.position = "fixed";
            textArea.style.top = 0;
            textArea.style.left = 0;
            textArea.style.width = "2em";
            textArea.style.height = "2em";
            textArea.style.padding = 0;
            textArea.style.border = "none";
            textArea.style.outline = "none";
            textArea.style.boxShadow = "none";
            textArea.style.background = "transparent";

            textArea.value = `https://portal.aawaazeducation.com/debate/${id}/`;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                var successful = document.execCommand("copy");
                var msg = successful ? "successful" : "unsuccessful";
                console.log("Copying text command was " + msg);
                this.$emit('toast', 'suc', 'Successfully created debate room and copied link to clipboard')
            } catch (err) {
                console.log("Oops, unable to copy");
            }
            document.body.removeChild(textArea);
        },
    },
};
</script>